import React from 'react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router';
import { createRoot } from 'react-dom/client';
import { SnackbarProvider } from 'notistack';
import './i18n';
import './utilities/amplifyConfigure';

// import App from './app';
import router from './router';
import { AuthProvider } from './hooks/useAuth';
import { LoggerProvider } from './hooks/useLogger';
import { NotificationsProvider } from './hooks/useNotifications';
import { PermissionsProvider } from './hooks/usePermissions';
import { SiteConfigProvider } from './hooks/useSiteConfig';
import { StoredConfigProvider } from './hooks/useStoredConfig';
import { TelemetryProvider } from './hooks/useTelemetry';

import store from './store';
import Theme from './components/Theme';

import { MobileProvider } from './hooks/useMobile';

const root = createRoot(document.getElementById('root'));

root.render(
	<Provider store={store}>
		<SiteConfigProvider>
			<MobileProvider>
				<TelemetryProvider>
					<StoredConfigProvider>
						<Theme>
							<SnackbarProvider maxSnack={4}>
								<LoggerProvider>
									<AuthProvider>
										<NotificationsProvider>
											<PermissionsProvider>
												<RouterProvider router={router} />
											</PermissionsProvider>
										</NotificationsProvider>
									</AuthProvider>
								</LoggerProvider>
							</SnackbarProvider>
						</Theme>
					</StoredConfigProvider>
				</TelemetryProvider>
			</MobileProvider>
		</SiteConfigProvider>
	</Provider>
);
